import { Calendar } from "primereact/calendar";
import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import XMLParser from "../../utilities/XMLParser";
import classNames from 'classnames';
import FormValidationUtils from "../../utilities/FormValidationUtils";
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import Utils from "../../utilities/Utils";
import { SCRIPT_ENV } from "../../config/RuntimeConfig";
import styled from 'styled-components';
import { spacing } from '../../theme';
import { displayField, getRootComponent } from "../../utilities/ElementUtils"; // Added import

class Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
  usedForFilter;
  hint;
  requiredLabel?: boolean=true;
}
const CheckboxContainer = styled.div<{
  indents?: string;
  marginTop?: string;
}>`
  margin-top: ${({ marginTop }) => marginTop ?? spacing.spacing0};
  margin-bottom: ${spacing.spacing7};
  margin-left: ${({ indents }) => {
    const val = parseInt(indents ?? '', 10);
    return !Number.isNaN(val) && val > 0 ? `${val}rem` : spacing.spacing0;
  }};
`;
interface State {


}
export class CheckboxComponent extends React.Component<Props, State> {

  constructor(props: Props) {
    super(props);
    const field = this.props.field;
    if (field) {
      field.IsDirty = false;
    }
  }

  componentDidMount(): void {
    let field = this.props.field;

    FormValidationUtils.runJavascript(field);
  }

  onCheckboxChange = (e) => {
    const val = (e.target.checked) ? 'Y' : 'N';

    // let control = this.props.field;
    let field = this.props.field;

    const sectionReadOnly = field.ReadOnly || field.parent?.parent?.SectionReadonly === true;
    if (!this.props.editable || sectionReadOnly) {
      e.preventDefault();
      e.target.checked = field.Value === 'Y';
      return;
    }
    field.Value = val;

    // if (!e.target.checked && this.props.field.Optional !== 'Y') {
    //   e.target.setAttribute('aria-invalid', 'true');
    //   e.target.setAttribute('aria-describedby', 'text-input-odometer-example-error-text');
    // } else {
    //   e.target.removeAttribute('aria-invalid');
    //   e.target.removeAttribute('aria-describedby');
    // }
 
    FormValidationUtils.markFieldDirty(field);
    FormValidationUtils.validateCheckbox(field);
    FormValidationUtils.runJavascript(field);

    if (field.EventScript && Utils.isNotNullOrEmpty(field.EventScript)) {
      try {
      const customEventFunc = eval(`(${field.EventScript})`);
      if (typeof customEventFunc === 'function') {
        customEventFunc(field, SCRIPT_ENV);
      }
      } catch (ex) {
      console.log(ex);
      }
    }

    this.props.callbackElement(getRootComponent(field));

  }

  render() {
    let field = this.props.field;

    let editable = this.props.editable;
    let controlArray = [];
    let displayfield: boolean = true;
    let title = this.props.title;

    const HtmlToReactParser = require('html-to-react').Parser;
    const htmlToReactParser = new HtmlToReactParser();
    const requireLabel = this.props.isEng ? "(required)" : "(obligatoire)";
    const shouldParseLabel =
      typeof title === "string" &&
      (field.richTextChecked || /<[^>]+>/.test(title));
    const labelContent = shouldParseLabel
      ? htmlToReactParser.parse(title)
      : title;
    let hintHtml = this.props.isEng ? field.Hint : field.HintFR;
    let hint;
    if (field.Hint) {
      hint = htmlToReactParser.parse(hintHtml);
    }
    displayfield = displayField(field);
    // the field script have high priority over th filter
    if(Utils.isNullOrEmpty(this.props.field.Script)){
      this.props.field.Visible =  displayfield;
    }
    const requiredLabel = this.props.field.Optional == "N" ? (this.props.isEng   ? "(required)"   : "(obligatoire)") : (this.props.isEng ? "(optional)" : "(facultatif)")

    const sectionReadOnly = field.ReadOnly || field.parent?.parent?.SectionReadonly === true;
    field.Disabled = sectionReadOnly;
    field.ReadOnly = sectionReadOnly;
//need to find out the root cause
    if(field.Value=="true" || field.Value==true){
      field.Value="Y";
    }
    if (editable) {
      controlArray.push(
        <CheckboxContainer key={'fd_Container_' + field.Id + "_" + field.Sequence} indents={field.indents?.toString()} marginTop={field.MarginTop}>
          <div style={{ display: field.Visible ? 'block' : 'none' }} key={'fd_Checkbox_' + field.Id + "_" + field.Sequence} title={field.TooltipENU} >

            {!getRootComponent(field).ErrorBottom && (
              <LiveValidationErrMsg
                field={this.props.field}
                isEng={this.props.isEng}
                key={"LiveValidationErrMsg_" + field.LoadBindName}
                id={`${field.LoadBindName}-${field.Id}`}
              />
            )}
            <div key={'div_' + field.Id + "_" + field.Sequence} className="ontario-checkboxes__item ontario-checkboxes__single-option" style={{ ...(getRootComponent(field).ErrorBottom && { marginBottom: '4px' }) }}>
              <input
                className={field.Valid? "ontario-checkboxes__input":"ontario-checkboxes__input ontario-checkboxes__error"}
                id={field.LoadBindName} 
                key={'fdIpt_checkboxes_' + field.Id}
                name="options" type="checkbox"
                aria-required={field.Optional !== 'Y'}
                aria-invalid={(!field.Valid && field.Touched) ? "true" : undefined}
                aria-describedby={
                  [!field.Valid && `${field.LoadBindName}-${field.Id}-error`, hintHtml && `hint-text-${field.LoadBindName}`]
                    .filter(Boolean)
                    .join(' ') || undefined
                }
                onChange={this.onCheckboxChange}
                checked={field.Value === 'Y'}
                readOnly={field.ReadOnly}
              />

              <label
                key={'fdIpt_label_' + field.Id}
                className="ontario-checkboxes__label"
                htmlFor={field.LoadBindName}
                style={{ display: 'inline-block', verticalAlign: 'top', maxWidth: '100%' }}
              >
                {labelContent} {this.props.requiredField && this.props.requiredLabel? 
                <span className="ontario-label__flag">
                  {getRootComponent(this.props.field).UseAsterisks == "Y" 
                  ? <span style={{ color: 'red' }}>*</span> 
                  : <span className='ontario-label__flag' style={{display:this.props.requiredLabel?"block":"none", fontSize: '0.875rem', fontWeight: 400}}>{requireLabel}</span>
                }
                </span> : null}
              </label>
            {hint ? <p className="ontario-hint" id={`hint-text-${field.LoadBindName}`} tabIndex={!field.Valid ? -1 : undefined}>{hint}</p> : null}
            </div>
            {getRootComponent(field).ErrorBottom && (
              <LiveValidationErrMsg
                field={this.props.field}
                isEng={this.props.isEng}
                key={"LiveValidationErrMsg_" + field.LoadBindName}
                id={`${field.LoadBindName}-${field.Id}`}
              />
            )}
          </div>
        </CheckboxContainer>
      );
    } else {
      // Access programContainer
      const programContainer = getRootComponent(field);

      controlArray.push(
        <div 
          key={'div_' + field.Id + "_" + field.Sequence} 
          className={programContainer.isHorizontalLayout ? 'pdf-row-column' : 'pdf-two-column'}
        >
                  <div key={'div2_' + field.Id + "_" + field.Sequence}>{labelContent}</div>
          <div key={'div3_' + field.Id + "_" + field.Sequence}>
            {this.props.isEng? field.Value == 'Y' ? "Yes" : "No": field.Value == 'Y' ? "Oui" : "Non"}
          </div>
        </div>
      )
    }

    return controlArray;
  }
}
